import React from 'react';
import SectionHeader from './../SectionHeader.jsx';
import Constants from './../../../constants/IncomeDistributionConstants';

export default class IncomeDistrubitionReview extends React.Component {
    constructor(props) {
        super(props);
    }

    renderHeader() {
        return (<SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} sectionName={this.props.content.sectionName} sectionMessage={this.props.sectionMessage}  />);
    }

    renderSectionDescription(message) {
        return (
            <div className="row simple-review-row">
                <div className="col-xs-12">
                    <span className="incomeDistribution__message">{message}</span>
                </div>
            </div>
        );
    }

    render() {
        const sectionHeader = this.renderHeader();
        let description;

        if(this.props.data.paymentMethod === Constants.reinvestedText) {
            description = this.props.content.reinvestedMessage;
        }else if(this.props.data.paymentMethod === Constants.bankAccountText) {
            description = this.props.content.toBankAccountMessage;
        }else if(this.props.data.paymentMethod === Constants.nominateText) {
            description = this.props.content.toBankAccountMessage;
        }

        return (
            <section className="confirm-simple-review" id={this.props.sectionId}>
                <div className="container">
                    {sectionHeader}
                    <div>
                        {description ? this.renderSectionDescription(description) : null}
                        {this.props.data.items && this.props.data.items.map(function (item, idx) {
                                return (
                                    <div key={`confirm_incomeDistribution_${idx}_row`} className="row simple-review-row incomeDistribution__row">
                                        <div className="col-xs-4">
                                            <span>{ item.label }</span>
                                        </div>
                                        <div className="col-xs-8">
                                            <span className="simple-review-value">{ item.value }</span>
                                        </div>
                                    </div>)
                            })
                        }
                    </div>
                </div>
            </section>
        )
    }
}

IncomeDistrubitionReview.propTypes = {
    data: React.PropTypes.object.isRequired,
    content: React.PropTypes.object,
    startLabel: React.PropTypes.string,
    sectionId: React.PropTypes.string
};




// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/IncomeDistribution/IncomeDistributionReview.jsx